import app from "@/main";
import TemelBilgileri from "./TemelBilgileri";
import HesapBilgisi from "./HesapBilgisi";
import Adres from "./Adres";
import {TakipRol} from "./TakipRolleri";
import {Mixins} from "../Mixins";
import {MessageLogger} from "../MessageLogger";
import Vekil from "./Vekil";
import {AvukatSorgulamaCevap} from "../../uyap/AvukatSorgulama";
import {DosyaFormDataInterface} from "../DosyaFormDataInterface";
import {MtsDosyaFormData} from "../MtsDosyaFormData";
import {IbanTercihiEnum} from "../../uyap/IbanTercihiEnum";

export default class TarafInterface extends MessageLogger {
    refId: string = "";
    tarafSifati: TakipRol = new TakipRol();
    adSoyad: string = "";
    kurumAdi: string = "";
    mersisNo: string = "";
    detsisNo: string = "";
    vergiNo: string = "";
    sorguTuru!: number;
    tarafTuru: string = ""; // KISI || KURUM
    temelBilgileri: TemelBilgileri = new TemelBilgileri();
    mernisAdresiKullan: boolean = false;
    alacakliMernisAdresiKullanilsin: boolean = false;
    adresBilgisi: Adres = new Adres();
    hesapBilgisi!: HesapBilgisi;
    isVekilIban: boolean = false;
    //MTS Different elements
    rolGirisBilgisi!: TakipRol;
    vekilListesi: AvukatSorgulamaCevap[] = [];
    ibanList: {
        kaynak: string,
        kisi: string,
        hesapBilgisi: HesapBilgisi
    }[] = [];
    selectedIbanIndex: number = 0;
    adresList: Adres[] = [];//[]; //adres birden fazla geliyorsa bu array da tutuyorum uyapla alakasi yok
    adresListPickedIndex: number = 0;
    tarafHashList: any[] = [];
    vekilListesiFromDom: any[] = [];
    alacakliIletisimEPosta: string = "";//"";
    alacakliIletisimTelefon: string = "";//"";
    selected: boolean = true;
    isMts: boolean = false;
    kurumMu: boolean = false;
    kisiMi: boolean = false;
    mernisAdresiVarMi: boolean = false;
    takipeDahilEt: boolean = true; // Checkbox seçim durumu için
    formData!: DosyaFormDataInterface | MtsDosyaFormData;

    isKurum() {
        return this.kurumMu;
    }

    isKisi() {
        return this.kisiMi;
    }

    setAlacakliMernisAdresiTercihi(alacakliMernisAdres: boolean): void {
        this.alacakliMernisAdresiKullanilsin = alacakliMernisAdres;
    }

    setMernisAdresiTercihi(mernisKullanilsinMiBool: boolean): void {
        this.mernisAdresiKullan = mernisKullanilsinMiBool;
    }

    getMernisAdresTercihi() {
        return this.mernisAdresiKullan;
    }

    getAlacakliMernisAdresTercihi() {
        return this.alacakliMernisAdresiKullanilsin;
    }

    getIsim() {
        if (this.isKisi())
            return `${this.temelBilgileri.adi} ${this.temelBilgileri.soyadi}`.trim();
        else
            return this.temelBilgileri.kurumAdi.trim();
    }

    isBorclu() {
        return this.tarafSifati.rolID == 22;
    }

    isAlacakli() {
        return this.tarafSifati.rolID == 21;
    }

    async setVekilListesi(): Promise<void> {
        console.log("Set vekil listesi called", this.vekilListesiFromDom);
        try {
            for (const vekil of this.vekilListesiFromDom) {
                try {
                    let vekilObj = Vekil.fromJson(vekil);
                    await vekilObj.runQuery();
                    if (vekilObj.vekil) {
                        this.vekilListesi.push(vekilObj.vekil);
                    }
                    //@ts-ignore
                } catch (e) {
                    console.error("HATA VekilListesi" + e.message);
                    this.addMessage("error", "Vekil Bulunamadı HATA - " + e.message);
                    throw new Error(e.message);
                }
            }
            //@ts-ignore
        } catch (e) {
            throw new Error(e.message);
        }

    }

    toUyapJson(key: number | null = null) {
        if (this.isMts)
            return this.mtsToUyapJson(key);
        const {
            vekilListesi,
            tarafSifati,
            sorguTuru,
            tarafTuru,
            temelBilgileri,
            mernisAdresiKullan,
            adresBilgisi,
            hesapBilgisi,
            ibanList,
            adresList,
            isVekilIban,
            adresListPickedIndex,
            mernisAdresiVarMi,
            selectedIbanIndex,
        } = this;

        let data: any = {
            vekilListesi,
            tarafSifati,
            sorguTuru,
            tarafTuru,
            temelBilgileri,
            mernisAdresiKullan,
            mernisAdresiVarMi,
            adresBilgisi,
            adresList,
            adresListPickedIndex,
            hesapBilgisi,
            ibanList,
            selectedIbanIndex,
            isVekilIban,

        };

        if(hesapBilgisi.kayitID == '' || hesapBilgisi.kayitID == null){
            hesapBilgisi.id = 0;
            hesapBilgisi.isSelected = true;
            hesapBilgisi.isVekilIban = isVekilIban;
        }

        if (tarafTuru == 'KISI')
            data['hesapBilgisi'] = hesapBilgisi
        if (tarafTuru == 'KURUM')
            data['adresBilgisi'] = adresBilgisi

        data["iban"] = hesapBilgisi;



        //iban yoksa silsin hesap bilgisini
        // hesapBilgisi: {ibanNumarasi:''} ,

        // if(this.formData.ibanTercihi == IbanTercihiEnum.Yok){
        //     data.hesapBilgisi = {
        //         ibanNumarasi:''
        //     }
        // }

        //if (data.hesapBilgisi.kayitID == '' || data.hesapBilgisi.kayitID == null || this.formData.ibanTercihi == IbanTercihiEnum.Yok) {
            //delete data.hesapBilgisi;
            //delete data.isVekilIban;
            //delete data.selectedIbanIndex;
        //}
        return data;
    }

    mtsToUyapJson(key: any) {
        console.log("MTS TO UYAP JSON");
        let {
            temelBilgileri,
            mernisAdresiKullan,
            adresBilgisi,
            hesapBilgisi,
            isVekilIban,
            tarafSifati,
            tarafTuru,
            alacakliIletisimEPosta,
            alacakliIletisimTelefon
        } = this;
        temelBilgileri.kisiKurumId = temelBilgileri.kisiKurumID;

        let adresList= [adresBilgisi];

        if(this.isKisi() && mernisAdresiKullan){
            //@ts-ignore
            if(temelBilgileri?.aktifMernisAdresiSorgusu){
                mernisAdresiKullan = true;
                adresList = [];
            }else{
                mernisAdresiKullan = false;
            }
            console.log("Kişide değişik şeyler var sorun oluyor");
        }
        else if(this.isKisi() && !mernisAdresiKullan){
            if(adresBilgisi?.adres.trim() == ""){
                this.mernisAdresiKullan = true;
                adresList = [];
            }
        }
        else{
            mernisAdresiKullan = false;
        }

        if(!adresBilgisi){
            //ADRES BULUNAMADI HATASI
            console.warn("********* adresBilgisi ADRES BİLGİSİ BULUNAMADI ***** ",this);
        }

        console.log("KAYITLI ADRESLER ADRES LİST",this.adresList);
        console.log("MERNİS ADRESİ KULLAN",mernisAdresiKullan);
        console.log("!!! this.alacakliMernisAdresiKullanilsin", this.alacakliMernisAdresiKullanilsin);
        console.log("!!!! adres bilgisi", adresBilgisi);
        console.log("!!!! giden adres list", adresList);

        let data: any = {
            viewId: tarafTuru.toLowerCase() + "_" + key,
            temelBilgiler: temelBilgileri,
            mernisAdresiKullan: mernisAdresiKullan,
            adresList: adresList,
            rolGirisBilgisi: tarafSifati,
            currentStatus: {
                tarafHesapBilgisi: {
                    selectedHesapBilgileriDVOList: []
                },
                vekilHesapBilgisi: {
                    selectedHesapBilgileriDVOList: []
                }
            }
        }

        if (alacakliIletisimEPosta != "" && alacakliIletisimTelefon != "") {
            data["alacakliIletisimEPosta"] = alacakliIletisimEPosta;
            data["alacakliIletisimTelefon"] = alacakliIletisimTelefon;
        }

        if (hesapBilgisi.ibanNumarasi != "" && hesapBilgisi.ibanNumarasi != null) {
            if (this.isAlacakli() && this.formData.ibanTercihi == IbanTercihiEnum.Avukat)
                data.currentStatus.vekilHesapBilgisi.selectedHesapBilgileriDVOList.push(hesapBilgisi);
            else
                data.currentStatus.tarafHesapBilgisi.selectedHesapBilgileriDVOList.push(hesapBilgisi);
        }
        console.log("TARAF MTS TO JSON DATA", data);
        return data;
    }

    setAddressIndex(index: number) {
        if (this.adresList[index]) {
            this.adresBilgisi = this.adresList[index];
            if (this.adresBilgisi.adresTuru == "ADRTR00013")//mernis adresi
                this.setMernisAdresiTercihi(true);
            else
                this.setMernisAdresiTercihi(false);
            this.adresListPickedIndex = index;
            return this.adresBilgisi
        } else {
            return {
                message: "Seçili index'de adres bulunamadı!",
                adresList: this.adresList
            }
        }
    }

    addAddress(adres: Adres): void {
        if (!adres) return;
        
        // Kaynak XML olarak işaretle
        adres.kaynak = "xml";
        
        // Adres listesine ekle
        this.adresList.push(adres);
        
        // Yeni eklenen adresi seç
        this.adresListPickedIndex = this.adresList.length - 1;
        this.adresBilgisi = adres;
        
        // Mernis adresi kontrolü
        if (adres.adresTuru == "ADRTR00013") {
            this.setMernisAdresiTercihi(true);
        } else {
            this.setMernisAdresiTercihi(false);
        }
    }

    addIBAN(iban: HesapBilgisi): void {
        if (!iban) return;
        
        // IBAN numarası kontrolü
        if (!iban.ibanNumarasi || iban.ibanNumarasi.trim() === '') return;
        
        // IBAN'ı listeye ekle
        this.ibanList.push({
            hesapBilgisi: iban,
            kaynak: "xml",
            kisi: IbanTercihiEnum.Muvekkil
        });
        
        // Yeni eklenen IBAN'ı seç
        this.selectedIbanIndex = this.ibanList.length - 1;
        this.hesapBilgisi = iban;
        this.isVekilIban = false;
    }

    setIbanIndex(index: number) {
        if (this.ibanList[index]) {
            this.hesapBilgisi = this.ibanList[index].hesapBilgisi;
            this.selectedIbanIndex = index;
            return this.hesapBilgisi
        } else {
            return {
                message: "Seçili index'de iban bulunamadı!",
                ibanList: this.ibanList
            }
        }
    }

    setVekil(tarafDomNode: Element, vekilList: Vekil[]) {
        console.log("SET VEKIL");
        if (!this.isMts && !this.isAlacakli()) {
            let vekilRefIds: any[] = [];
            tarafDomNode.querySelectorAll('ref').forEach(
                (refNode) => {
                    vekilRefIds.push(refNode.getAttribute('id'))
                });
            console.log("VEKIL LIST", vekilList);
            console.log("vekilRefIds LIST", vekilRefIds);
            vekilList.forEach(vekil => {
                if (vekilRefIds.find(id => id == vekil.refId))
                    this.vekilListesiFromDom.push(vekil);
            });
        }
    }

    async runQueryForMtsHesapBilgisi(): Promise<void> {
        console.log("runQueryForMTSHesapBilgisi ");
        try {
            let ibanNo = Mixins.onlyDigit(this.hesapBilgisi.ibanNumarasi);
            let hesapBilgisi = await app.$uyap.GetIbanDetails().run({iban: ibanNo, isSansurlenecek: false});
            if (hesapBilgisi.bankaAdi.trim() != "T.VAKIFLAR BANKASI T.A.O.") {
                //return rej()
            }
            this.hesapBilgisi = hesapBilgisi;
            return Promise.resolve();
        } catch (err) {
            console.log("IBAN runQueryForHesapBilgisi ERR", err);
            return Promise.reject(err);
        }
    }

    async runQueryForHesapBilgisi(): Promise<void> {
        return new Promise(async (resolve, reject) => {
            try {
                let ibanTercihi = this.formData.ibanTercihi;
                // vekilin iban'nı uyap'tan almış ol
                let ibanNo = Mixins.onlyDigit(this.hesapBilgisi.ibanNumarasi);
                let ibanList = await app.$uyap.AvukatKayitliIbanList().run({});
                if (ibanList.type != "error") {
                    this.ibanList = ibanList.value.map((avukatIban: any) => {
                        return {
                            hesapBilgisi: avukatIban,
                            kaynak: 'UYAP',
                            kisi: IbanTercihiEnum.Avukat
                        }
                    });
                }

                let xmlIbaniBulundu = false;
                if (ibanNo != "") {
                    try {
                        let hesapBilgisi = await app.$uyap.GetIbanDetails().run({
                            iban: ibanNo,
                            isSansurlenecek: false
                        });
                        if (typeof hesapBilgisi.id == "undefined")
                            hesapBilgisi.id = 0;
                        this.ibanList.push(
                            {
                                hesapBilgisi: hesapBilgisi,
                                kaynak: "XML",
                                kisi: IbanTercihiEnum.Muvekkil
                            }
                        );
                        xmlIbaniBulundu = true;
                    } catch (e) {
                        console.error("xmlden sorgulanan iban bulunamadi!", {ibanNo, hata: e});
                    }
                }

                // alacaklının uyap'tan
                try {
                    let uyapIbanList = await app.$uyap.GetIbanListesi().run({
                        kisiKurumId: this.temelBilgileri.kisiKurumID,
                        tarafTur: 1
                    });
                    uyapIbanList.forEach((item: HesapBilgisi) => {
                        this.ibanList.push({
                            hesapBilgisi: item,
                            kaynak: 'UYAP',
                            kisi: IbanTercihiEnum.Muvekkil
                        })
                    });
                } catch (e) {
                    console.error("Uyaptan iban bilgisi alınamadı", e)
                }

                if (this.ibanList.length > 0) {
                    console.log((this.getIsim() + " IBAN:"), {
                        tercih: ibanTercihi,
                        list: this.ibanList
                    })
                    // IBAN tercihine göre seçim yap
                    if (ibanTercihi == IbanTercihiEnum.Muvekkil || ibanTercihi == IbanTercihiEnum.Yok) {
                        // Müvekkil IBAN'ı seç - XML öncelikli
                        if (xmlIbaniBulundu) {
                            // XML IBAN'ı seç
                            this.selectedIbanIndex = this.ibanList.findIndex(v => v.kaynak == "XML");
                            if (this.selectedIbanIndex >= 0) {
                                this.hesapBilgisi = this.ibanList[this.selectedIbanIndex].hesapBilgisi;
                                this.isVekilIban = false;
                            }
                        } else {
                            // XML IBAN yoksa, UYAP'tan gelen ilk müvekkil IBAN'ını seç
                            this.selectedIbanIndex = this.ibanList.findIndex(v =>
                                v.kisi == IbanTercihiEnum.Muvekkil &&
                                v.kaynak == "UYAP"
                            );
                            if (this.selectedIbanIndex >= 0) {
                                this.hesapBilgisi = this.ibanList[this.selectedIbanIndex].hesapBilgisi;
                                this.isVekilIban = false;
                            }
                        }
                        return resolve();
                    }

                    // Avukat IBAN'ı seç
                    this.selectedIbanIndex = this.ibanList.findIndex(v =>
                        v.kisi == IbanTercihiEnum.Avukat &&
                        v.hesapBilgisi.ibanNumarasi == this.formData.avukatIban
                    );
                    if (this.selectedIbanIndex >= 0) {
                        this.hesapBilgisi = this.ibanList[this.selectedIbanIndex].hesapBilgisi;
                        this.isVekilIban = true;
                    } else {
                        // Eşleşen avukat IBAN bulunamadı, ilk avukat IBAN'ını seç
                        this.selectedIbanIndex = this.ibanList.findIndex(v => v.kisi == IbanTercihiEnum.Avukat);
                        if (this.selectedIbanIndex >= 0) {
                            this.hesapBilgisi = this.ibanList[this.selectedIbanIndex].hesapBilgisi;
                            this.isVekilIban = true;
                        }
                    }
                    return resolve();
                } else {
                    //{message: "İban bilgisi hatalı: İban bulunamadı"}
                    return reject({message: "İban bilgisi hatalı: İban bulunamadı"});
                }
            } catch (err) {
                console.error("IBAN runQueryForHesapBilgisi ERR", err);
                return reject(err);
            }
        })
    }
}

